<template>
  <div id="preview" ref="preview" :class="{'isWxapp':$store.state.openId}" :style="{width: viewWidth + 'px', height: viewHeight + 'px',backgroundColor:canvasBgColor,transform:'scale('+scale+','+scale+')'}"><!-- ,transform:'scale('+scale+')',zoom:scale -->
    <controlItem v-for="item,i in DragList" :key="i" class="p-a" :item="item" v-if="!item.deleted" :isCompany="isCompany" :altDown="altDown" @mqttUrl="PushMqtt" @showDataBlock="showData" @showRoot="showFunction" ref="control"></controlItem>
    <AttrBlackboard ref="addrobot" :isCompany="isCompany" v-if="!$store.state.openId"></AttrBlackboard>
    <div class="mask" v-show="$store.state.mask" v-if="!$store.state.openId"></div>
    <!-- <div v-if="$store.state.openId" style="color: aliceblue; font-size: 28px;position: absolute; top: 50px;left: 100px; z-index: 5000;" @click="changeScale">changeScale {{scale}}</div> -->
    <!-- <div v-if="$store.state.openId" style="color: aliceblue; font-size: 28px;position: absolute; top: 90px;left: 100px; z-index: 5000;" @click="changeScale">{{previewWidth}} {{previewHeight}} {{isClear}}</div> -->
    <!-- 验证码授权 -->

    <!-- 验证码授权 -->
    <div class="popup" v-if='functionShow'>
      <div class="popup-clear" id="privilege" style="height: 349px;text-align: left;margin-left: -216px;top: calc(50% - 300px); z-index:99999999 !important;">
          <div class="popup-title">
              获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close" id="closeClear3"></i>
          </div>
          <div class="popup-lab">
              手机号：
              <el-input disabled v-model="phone">{{phone}}</el-input>
          </div>
          <div class="popup-lab clearfix">
              <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
              <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                  <el-form-item prop="verifyCode">
                      <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                  </el-form-item>
              </el-form>
              <div class="code-box" style="margin-top: 4px;">
                  <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                  <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
              </div>
          </div>
          <div class="popup-lab">
              <p class="btn-box" style="margin-top: 26px;">
                  <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                  <el-button @click="close" id="closeClear4">取消</el-button>
              </p>
          </div>
      </div>
    </div>

    <!-- 下发指令-手动输入 -->
    <div class="popup" v-if='$store.state.showManualInput'>
      <div class="popup-clear" style="height: 249px;width: 360px; text-align: left;margin-left: -216px;top: calc(50% - 300px); z-index:1000 !important;">
          <div class="popup-title">
              下发指令<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close"></i>
          </div>
          <div class="popup-lab clearfix" style="margin-bottom: 0;">
              <p style="position: relative; left: -11px;"><i class="star">*</i>属性值：</p>
              <el-form style="float: left; width: 300px;" :model="verifyForm" :rules="rules" ref="attrValForm" @submit.native.prevent>
                  <el-form-item prop="attrVal">
                      <el-input class="verifyCode" placeholder="请输入属性值" v-model='verifyForm.attrVal' ></el-input>
                  </el-form-item>
              </el-form>
          </div>
          <div class="popup-lab">
              <p class="btn-box btn-box2" style="margin-top: 20px;">
                <el-button type="primary" @click="setPropertyValue" :loading="setLoading">确定</el-button>
                <el-button @click="close">取消</el-button>
              </p>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { JSONParse,JSONStringify,unzip,zip } from "../config/functions.js"
  import controlItem from "./controlItem"
        // import Vconsole from 'vconsole'
  import 'echarts-liquidfill/src/liquidFill.js'
	import AttrBlackboard from './attrBlackBoard/AttrBlackboard'
  import IndexDBCache from "../config/indexDB.js";
  var dbCache = null;
  export default {
    data(){
      return {
        notes:require('@/assets/image/organize/notes.png'),
        screen:{},
        viewWidth:1920, //画布宽
        viewHeight:1080,  //画布高
        canvasBgColor:'#151515',  //画布背景
        isCompany:false,  //当前大屏是否为企业所属
        MqttClient:null,  //mqtt客户端对象
        companyList:[], //企业列表
        mqttUrlList:[], //mqtt订阅主题列表
        altDown:false,
        scale:1,  //移动端缩放等级
        zoom:1,
        // 验证码授权
        verifyForm:{
            verifyCode:'',
            attrVal:""
        },
        rules:{     //验证规则
            verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }],
            attrVal:[{ message: '请输入属性值', required: true, trigger: 'blur' }],
        },
        second:60,
        getCodeShow:true,
        countdownShow:false,
        functionShow:false,
        phone:'',
        time:null,
        setLoading:false,
        // displacement:{},
        // previewWidth:824,
        // previewHeight:1572,
        // isClear:false,
        // minZoom:null
      }
    },
    components:{controlItem,AttrBlackboard},
    computed:{
      DragList(){
        return this.$store.state.DragList
      },
      userCode(){
        return this.$store.state.userData.code
      },
      companyId(){
        return this.$store.state.companyId
      }
    },
    created(){
      let companyLogo = this.$store.state.companyLogo
      let mute = this.$store.state.userConfig.mute
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem("store"))))
      // console.log(mute,this.$store.state.mute)
      this.$store.state.deviceWarningList = []
      this.$store.state.Processing = false
      this.$store.state.showProupId = null
      let screenData, content
      // 微信小程序需要引入2个依赖
      if(this.$route.query.wid){
        this.$store.state.openId = this.$route.query.wid
        // let app = document.getElementById('app')
        // app.style.height = 0
        // console.log(app)
        document.write('<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.4.0.js"><\/script>');
        document.write('<script type="text/javascript" src="https://unpkg.com/@dcloudio/uni-webview-js@0.0.3/index.js"><\/script>');
        // 小程序端开启手势缩放
        document.querySelector('meta[name="viewport"]').setAttribute('content','maximum-scale=2, minimum-scale=0.5,initial-scale=1.0')
        document.addEventListener('UniAppJSBridgeReady', function() {
          // uni api依赖注入成功
            // console.log(uni)
            // uni.postMessage({
            //   data: {
            //     action: 'message'
            //   }
            // })
        });
        this.getUserMenus()
        this.getConfig()
      }
      this.getProductList()
      // type1 - 正式版
      if(this.$route.query.type==1){
        this.get('/Screen/get',{id:this.$route.query.id}).then(res=>{
          if(res.success){
            let obj = res.result
            // localStorage.setItem('screen',zip(JSONStringify(obj)))
            localStorage.setItem('screenGroupCode',obj.groupCode)
            content = JSONParse(obj.context)
            screenData = obj
            // console.log(obj)
            this.setWindowTitle('运维大屏 - '+obj.name)
            this.initView(screenData,content)
          }else{
            this.screen = res
            this.$message({
              type:"warning",
              message:"获取大屏数据失败："+res.message
            })
          }
        })
        if(this.$route.path=='/CompanyConsole/indexPreview'){
          this.$store.state.companyTitle = document.title;
          this.$store.state.companyLogo = companyLogo
          this.$store.state.userConfig.mute = mute
          this.$store.state.headerActive = 0;
        }
        // this.addListenerTouch()
      }else{
        // 预览模式从本地缓存和indexDB取
        let that = this
        screenData = JSONParse(unzip(localStorage.getItem('screen')))
        dbCache = new IndexDBCache((msg) => {
          dbCache.Record_Get(that.$route.query.dbCacheId).then(res=>{
            if(res.content){
              content = JSONParse(unzip(res.content))
              // console.log(screenData)
              this.setWindowTitle('运维大屏 - '+screenData.name)
              this.initView(screenData,content)
            }else{
              // console.error(res)
              this.$message({
                message: `获取大屏配置数据失败`,
                type: 'warning'
              });
            }
          })
        });
        // content = JSONParse(unzip(localStorage.getItem('content')))
        // console.log(unzip(localStorage.getItem('screen')))
        // console.log(unzip(localStorage.getItem('content')))
        // this.initView(screenData,content)
      }

    },
    mounted() {
      // console.log(this.$route.query)
      this.keyDown()
      this.phone=this.hidePhone(this.$store.state.userData.mobile);
      // 开启微信端调试
      // if(this.$route.query.wid){
      //   let vConsole = new Vconsole()
      //   Vue.use(vConsole)
      // }
      window.onresize = (e)=>{
        // console.log(e)
        if(this.$store.state.openId){
          let windowWidth = document.documentElement.clientWidth
          if(windowWidth<Number(this.viewWidth)){
            this.scale = windowWidth / Number(this.viewWidth)
          }
          // 添加手势监听 - 缩放
          // this.addListenerTouch()
        }
      }
    },
    beforeDestroy(){
      this.keyDownReview()
    },
    methods:{
      //获取系统配置
      getConfig(){
          this.get('/SystemConfig/getList').then((res)=>{
              if(res.success){
                  for(let obj of res.result){
                      if(obj.name == 'verifyCodeModule'){
                          let value = obj.value
                          localStorage.setItem('verifyCodeModule',value)
                          //console.log(value)

                      }
                  }
              }
          })
      },
      //获取权限
      getUserMenus(){
          this.get('/Authority/userMenus').then((res)=>{
              if(res.success){
                  this.$store.state.userMenus = res.result
                  this.getFuncList();
              }else{
                  this.$message({
                      type: 'warning',
                      message: `获取用户权限失败：${res.message}`
                  })
              }
          })
      },
      // 获取功能集
      getFuncList(){
          this.get('/Function/getList').then((res)=>{
              if(res.success){
                  this.$store.state.functionList=[]
                  for(let menu of this.$store.state.userMenus){
                      for(let func of res.result){
                          if(menu == func.id){
                              this.$store.state.functionList.push(func.code)
                          }
                      }
                  }
              }
          })
      },
      setWindowTitle(title){
        if(this.$store.state.openId){
          document.title = "运维大屏"; // 动态修改网站标题
        }else if(this.$route.path=='/indexPreview'){
          document.title = title; // 动态修改网站标题
          let link=require('@/assets/image/index/favicon'+this.cssType+'.png')
          let $favicon = document.querySelector('link[rel="icon"]');
          if ($favicon !== null) {
              $favicon.href = link;
          } else {
              $favicon = document.createElement("link");
              $favicon.rel = "icon";
              $favicon.href = link;
              document.head.appendChild($favicon);
          }
        }
      },
      // 获取产品列表
      getProductList(){
        this.get('/Product/getList').then(res=>{
          if(res.success){
            this.$store.state.productList = res.result.map(item=>{
              try{
                item.tsl = JSON.parse(item.tsl)
              }catch(err){
                item.tsl = ''
                // console.log(err)
                // console.log("111111111111",item)
              }
              return item
            })
            // console.log(this.$store.state.productList)
          }else{
            this.$message({
              message: `获取产品列表失败：${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      // 随机缩放 - 测试
      // changeScale(){
      //   this.scale = Math.random()*(1.5-0.5+1)+0.5;
      //   let dom = document.getElementById("preview")
      //   this.previewHeight = dom.offsetHeight;
      //   this.previewWidth = dom.offsetWidth;
      //   console.log(dom,this.previewWidth,this.previewHeight,document.body.offsetWidth,document.body.offsetHeight)
      // },
      //关闭弹窗
      close(name){
          this.functionShow=false;
          if(this.$refs.addrobot.$el.style.display!='block'){
            this.$store.state.mask=false;
          }
          this.verifyForm.verifyCode = ''
          this.verifyForm.attrVal = ''
          this.$store.state.showManualInput = false
          this.$store.state.ManualInputObj = null
      },
      setPropertyValue(){
        this.setLoading=true
        let data = {
          deviceCode: this.$store.state.ManualInputObj.attrCode[0],
          property: this.$store.state.ManualInputObj.attrCode[1],
          value: this.verifyForm.attrVal
        }
        this.post('/Device/setPropertyValue', data).then(res => {
          this.setLoading=false
          this.close()
          if (res.success) {
            // setTimeout(()=>{
            //   loading.close()
              this.$message({
                type: 'success',
                message: "指令下发成功"
              })
            // },1000)
          } else {
            this.setLoading=false
            // loading.close()
            this.$message({
              type: 'warning',
              message: "指令下发失败：" + res.message
            })
          }
        }).then(()=>{
          this.setLoading=false
        })
      },
      // 获取验证码
      getCode(){
          this.get('/UserProfile/sendVerifyCode').then((res)=>{
              if(res.success){
                  this.getCodeShow=false
                  this.countdownShow=true
                  const TIME_COUNT = 60;
                  this.$message({
                      message: '验证码发送成功',
                      type: 'success'
                  });
                  if (!this.timer) {
                      this.second = TIME_COUNT;
                      this.timer = setInterval(() => {
                          if (this.second > 0 && this.second <= TIME_COUNT) {
                              this.second--;
                          } else {
                              this.getCodeShow = true;
                              this.countdownShow=false;
                              clearInterval(this.timer);
                              this.timer = null;
                          }
                      }, 1000)
                  }
              }else{
                this.$message({
                  message: `${res.message}`,
                  type: 'warning'
                });
              }
          })
      },
      // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            let VerifyArr = localStorage.getItem('verifyCodeModule').split(',').map(Number)
                            VerifyArr.splice(VerifyArr.indexOf(12),1)
                            localStorage.setItem('verifyCodeModule',VerifyArr)
                            this.functionShow=false
                            if(this.$refs.addrobot.$el.style.display!='block'){
                              this.$store.state.mask=false;
                            }
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
        // 打开提权弹窗
        showFunction(){
          // this.$store.state.mask = true
          this.functionShow = true
        },
      // 初始化数据
      initView(screenData,content){
        // console.log(content)
        if(content.isZip){
          // console.log(content.dragList)
          content.dragList = JSONParse(unzip(content.dragList))
        }
        // 当前所属组织为企业
        if(content.companyId&&screenData.groupCode.substr(0,1)=="E"){
          this.$store.state.companyId = content.companyId||content.groupId
        }
        if(screenData){
          this.screen = screenData
          // 开启mqtt
          this.mqttMSG()
          // 当前所属组织为企业
          if(screenData.groupCode.substr(0,1)=="E"){
            this.isCompany = true
            // 获取企业
            this.get("/Company/get",{code:screenData.groupCode}).then(res=>{
              if(res.success){
                let company = res.result[0]
                this.companyList.push(res.result[0])
                this.$store.state.companyId = company.id
                // 获取企业的设备列表
                this.get('/Device/getList',{companyId:company.id}).then(res2=>{
                  // console.log(1)
                  if(res2.success){
                    for(let item of res2.result){
                      item.propertySet=item.propertySet.split(',')  //将关联属性转成数组
                      item.leaf=false //用于懒加载
                    }
                    company.deviceList = this.clone(res2.result)
                    if(content){
                      this.viewWidth = content.viewWidth
                      this.viewHeight = content.viewHeight
                      this.canvasBgColor = content.BgColor
                      this.$store.state.canvasBgColor = content.BgColor
                      // 遍历获取数据
                      this.mapScrenn(content.dragList)
                    }
                    // 当前为微信小程序环境
                    if(this.$store.state.openId){
                      let windowWidth = document.documentElement.clientWidth
                      if(windowWidth<Number(this.viewWidth)){
                        this.scale = windowWidth / Number(this.viewWidth)
                      }
                      // 添加手势监听 - 缩放
                      // this.addListenerTouch()
                    }
                    this.$nextTick(()=>{
                      this.$forceUpdate()
                    })
                  }else{
                    this.$message({
                      type:"warning",
                      message:"获取设备列表失败："+res2.message
                    })
                  }
                  // 获取虚拟设备
                  this.get('/VirtualDevice/get',{companyId:company.id}).then(res3=>{
                    if(res3.success){
                      res3.result.name = "虚拟设备"
                      res3.result.noBool = true
                      company.deviceList.unshift(res3.result)
                      this.$nextTick(()=>{
                        this.$forceUpdate()
                      })
                    }else{
                      this.$message({
                        type:"warning",
                        message:"获取虚拟设备失败："+res3.message
                      })
                    }
                  })
                  // console.log(company)
                })
              }else{
                this.$message({
                  type:"warning",
                  message:"获取企业数据失败："+res.message
                })
              }
            })
          }else if(content){
            this.viewWidth = content.viewWidth
            this.viewHeight = content.viewHeight
            // 小程序 - 页面适应
            if(this.$store.state.openId){
              let windowWidth = document.documentElement.clientWidth
              if(windowWidth<Number(this.viewWidth)){
                this.scale = windowWidth / Number(this.viewWidth)
              }
              // this.addListenerTouch()
            }
            this.canvasBgColor = content.BgColor
            this.$store.state.canvasBgColor = content.BgColor
            // this.$set(this.$store.state,'DragList',content.dragList)
            this.mapScrenn(content.dragList)
          }
        }else if(content){
          this.viewWidth = content.viewWidth
          this.viewHeight = content.viewHeight
          this.canvasBgColor = content.BgColor
          this.$store.state.canvasBgColor = content.BgColor
          // this.$set(this.$store.state,'DragList',content.dragList)
          this.mapScrenn(content.dragList)
        }
        // console.log(this.$store.state.companyId)
      },
      // 微信端添加手势监听
      addListenerTouch(){
        // if(this.$store.state.openId){
        //   let windowWidth = document.documentElement.clientWidth
        //   if(windowWidth<Number(this.viewWidth)){
        //     this.scale = windowWidth / Number(this.viewWidth)
        //   }
        // }
        return
        var self = this, minScale = this.scale
        document.addEventListener('touchstart',function(e){
          var touches = e.touches
          // self.isClear = false
          var one = touches[0],two = touches[1]
          // 记录第一个手指的位置
          self.displacement.pageX = one.pageX
          self.displacement.pageY = one.pageY
          self.displacement.moveable = true
          // 记录第二个手指的位置
          if(two){
            self.displacement.pageX2 = two.pageX
            self.displacement.pageY2 = two.pageY
          }
          // 记录当前缩放等级
          self.displacement.oldScale = self.scale
        })
        document.addEventListener('touchmove',function(e){
          if(!self.displacement.moveable){
            return
          }
          var touches = e.touches
          var one = touches[0],two = touches[1]
          if(two){
            e.preventDefault()
            if(!self.displacement.pageX2){
              self.displacement.pageX2 = two.pageX
            }
            if(!self.displacement.pageY2){
              self.displacement.pageY2 = two.pageY
            }
            // 计算比例
            var zoom = self.getDistance(
              {x:one.pageX,y:one.pageY},
              {x:two.pageX,y:two.pageY},
            ) / self.getDistance(
              {x:self.displacement.pageX,y:self.displacement.pageY},
              {x:self.displacement.pageX2,y:self.displacement.pageY2},
            )

            var newScale = self.displacement.oldScale * zoom
              self.zoom = zoom
            if(newScale<=minScale){
              self.displacement.newScale = minScale
              self.scale = minScale
            }else if(newScale>=(1/minScale)){
              self.displacement.newScale = 1/minScale
              self.scale = 1/minScale
            }else{
              self.displacement.newScale = newScale
              self.scale = newScale
            }
          }
        })
        document.addEventListener('touchend',function(e){
          if(self.displacement.pageX2||self.displacement.pageY2){
            let maptree = function(arr){
              // console.log(arr)
            	arr.forEach(item=>{
            		if(item.type=='graph'){
            			let dom = document.getElementById("graph" + item.id)
            			// dom.removeAttribute('_echarts_instance_')
            			if(dom){
                    let echart = self.$echarts.getInstanceByDom(dom)
                    if (!echart) {
                      echart = self.$echarts.init(dom)
                    }else{
                      echart.clear()
                      // self.isClear = true
                      // console.log('clear')
                    }
                    echart.setOption(item.options)
                    echart.resize();
                    // self.$forceUpdate()
                    let control = self.$refs["graph" + item.id]
                    if(control){
                      control.viewUpdate()
                    }
                  }
            		}else{
            			if(item.type=='makeUp'||item.type=='proup'){
            				maptree(item.children)
            			}else if(item.type=='panel'){
            				let block = item.blockContentList.find(block=>block.id==item.activeBlock)
            				// item.blockContentList.forEach(block=>{
            					if(block&&block.drags&&block.drags.length){
                        maptree(block.drags)
                      }
            				// })
            			}
            		}
            	})
            }
            // 遍历获取对应的属性看板
            maptree(self.DragList)
          }
          self.displacement= {}
          self.$forceUpdate()
        })
      },
      // 获取平方根
      getDistance(start,stop){
        return Math.hypot(stop.x-start.x,stop.y-start.y)
      },
      // 遍历控件获取数据
      async mapScrenn(tree){
        let dataArr=[],mqttArr = [],self = this
        let mapTree=await function(arr){
          arr.forEach(item =>{
            if(!item.deleted){
              let companyId = self.isCompany?self.$store.state.companyId:item.companyId,company
              // debugger
              if(companyId){
                if(dataArr.find(obj=>obj&&obj.companyId==companyId)){
                  company=dataArr.find(obj=>obj.companyId==companyId)
                }else{
                  company={companyId:companyId,deviceCodes:[]}
                  dataArr.push(company)
                }

                if(item.type=="chartTime"){
                  // console.log(item)
                  if(item.dateType==2){
                    let now = new Date(),
                        nowY = now.getFullYear(),
                        nowM = now.getMonth()+1,
                        nowD = now.getDate(),
                        nowH = now.getHours()
                    item.timeVal = new Date(`${nowY}/${nowM}/${nowD} ${nowH}:00:00`).getTime()

                  }else if(item.dateType==3){
                    let now = new Date(),
                        nowY = now.getFullYear(),
                        nowM = now.getMonth()+1,
                        nowD = now.getDate()
                    item.timeVal=new Date(`${nowY}/${nowM}/${nowD} 00:00:00`).getTime()
                  }else if(item.dateType==5){
                      let now = new Date(),
                          nowY = now.getFullYear(),
                          nowM = now.getMonth()+1
                      item.timeVal= new Date(`${nowY}/${nowM}/1 00:00:00`).getTime()

                  }else if(item.dateType==7){
                      let now = new Date(),
                          nowY = now.getFullYear()
                     item.timeVal=new Date(`${nowY}/1/1 00:00:00`).getTime()

                  }
                }
                // 设备属性看板
                if(item.DeviceAttrBlock&&item.DeviceAttrBlock.length&&item.DeviceCode&&!company.deviceCodes.includes(item.DeviceCode)){
                  company.deviceCodes.push(item.DeviceCode)
                }
                // 获取关联的设备
                if(item.type == "textSpan" && item.spanShowValue){ // 文本标签
                  if(item.DeviceAttr && item.DeviceAttr[0] && !company.deviceCodes.includes(item.DeviceAttr[0])){
                    company.deviceCodes.push(item.DeviceAttr[0])
                    mqttArr.push(`sys/device/${item.DeviceAttr[0]}/property/push`)
                  }
                  if(item.ShowAttrCode&&item.ShowAttrCode.length && item.ShowAttrCode[0] && !company.deviceCodes.includes(item.ShowAttrCode[0])){
                    company.deviceCodes.push(item.ShowAttrCode[0])
                    mqttArr.push(`sys/device/${item.ShowAttrCode[0]}/property/push`)
                  }
                }else if((item.type == "conduit" || item.controlId == 12) && item.DeviceAttr && item.DeviceAttr[0] && !company.deviceCodes.includes(item.DeviceAttr[0])){ //管道和指示灯
                  company.deviceCodes.push(item.DeviceAttr[0])
                  mqttArr.push(`sys/device/${item.DeviceAttr[0]}/property/push`)
                }else if(item.type == "progress" && item.progressAttr){ //进度条
                  if(item.progressAttr[0] && !company.deviceCodes.includes(item.progressAttr[0])){
                    company.deviceCodes.push(item.progressAttr[0])
                    mqttArr.push(`sys/device/${item.progressAttr[0]}/property/push`)
                    if(item.colorAttr&&item.colorAttr[0]&&!company.deviceCodes.includes(item.colorAttr[0])){
                      company.deviceCodes.push(item.colorAttr[0])
                      mqttArr.push(`sys/device/${item.colorAttr[0]}/property/push`)
                    }
                  }
                }else if(item.controlId == 11 && item.DeviceId){  //报警灯
                  let device = self.$store.state.deviceWarningList.find(obj => obj.deviceId == item.DeviceId)
                  if(!device){
                    let device = {
                      deviceId: item.DeviceId,
                      DeviceCode: item.DeviceCode,
                      status: 1
                    }
                    mqttArr.push(`sys/device/${item.DeviceCode}/status/push`)
                    self.$store.state.deviceWarningList.push(device)
                  }
                }else if((item.type == "circular" || item.type == "rectangle") && item.colorAttr && item.colorAttr[0] && !company.deviceCodes.includes(item.colorAttr[0])){ //矩形和圆形
                  company.deviceCodes.push(item.colorAttr[0])
                  mqttArr.push(`sys/device/${item.colorAttr[0]}/property/push`)
                }else if(item.type == "control"){  //图片素材
                  if(!company.deviceCodes.includes(item.DeviceCode)&&item.DeviceCode){
                    company.deviceCodes.push(item.DeviceCode)
                    mqttArr.push(`sys/device/${item.DeviceCode}/property/push`)
                  }
                  if(item.statusAttr && item.statusAttr[0] && item.statusAttr[0] != item.DeviceCode&&!company.deviceCodes.includes(item.statusAttr[0])){
                    mqttArr.push(`sys/device/${item.statusAttr[0]}/property/push`)
                    company.deviceCodes.push(item.statusAttr[0])
                  }
                }
              }
              if((item.type=='makeUp'||item.type=='proup')&&item.children&&item.children.length){   //组合和弹窗
                mapTree(item.children)
              }else if(item.type=='panel'){
                item.blockContentList.forEach(block=>{
                  if(block.drags.length){
                    mapTree(block.drags)
                  }
                })
              }
            }
          })
        }
        mapTree(tree)
        let mqttUrlArr = Array.from(new Set(mqttArr))
        for(let url of mqttUrlArr){
          // 订阅mqtt
          this.PushMqtt(url)
        }
        // 获取数据
        // console.log(dataArr)

        this.getData(dataArr,tree)
      },
      // 获取每个控件关联的数据
      getData(arr,tree){
        // console.log(arr,tree)
        if(arr.length==0){
          this.$set(this.$store.state,'indexPreviewData',arr)
          this.$set(this.$store.state,'DragList',tree)
          return
        }
        for(let i in arr){    //遍历企业
          if(arr[i].deviceCodes.length){
            if(arr[i].deviceList&&arr[i].deviceList.length){
              let index = 0
              for(let code of arr[i].deviceCodes){  //遍历设备
                let device = arr[i].deviceList.find(dev=>dev.code == code)
                if (device) {
                  // this.getDeviceData(companyId,device)
                  // 获取属性值
                  if (deviceCode.substr(0, 2) == "_V" && !device.valueList) {
                    this.get('/VirtualDevice/getPropertyValue', {
                      deviceId: device.id
                    }).then(res => {
                      if (res.success) {
                        device.valueList=res.result.map(item=>{
                          item.value=Number(item.value)
                          return item
                        })
                        // this.$set(device, 'valueList', res.result)
                        this.$forceUpdate()
                      }
                    })
                  } else if (!device.valueList) {
                    this.get('/Device/getPropertyValue', {
                      deviceId: device.id
                    }).then(res => {
                      // debugger
                      if (res.success) {
                        device.valueList=res.result.map(item=>{
                          item.value=Number(item.value)
                          return item
                        })
                        // this.$set(device, 'valueList', res.result)
                        // this.$forceUpdate()
                      }
                    })
                  }
                  // 获取设备属性tsl
                  this.getDeviceAttrData(arr[i].companyId, device)
                }
                if(i==arr.length-1&&index==arr[i].deviceCodes.length-1){
                  this.$set(this.$store.state,'indexPreviewData',arr)
                  this.$set(this.$store.state,'DragList',tree)
                  // console.log(this.$store.state.indexPreviewData)
                  var timer = setTimeout(() =>{
                    if(!this.$refs.control){
                      clearTimeout(timer)
                      return
                    }
                    this.$refs.control.forEach((control)=>{
                      if(control.item.type!="graph"&&control.item.type!="list"&&control.item.type!="ranking"){
                        control.viewUpdate()
                      }
                    })
                    clearTimeout(timer)
                  }, 200);
                }
                index+=1
              }
            }else{
              arr[i].deviceList = []    //获取设备列表
              this.get('/Device/getList', {companyId: arr[i].companyId}).then(res => {
                  // console.log(2)
                if(res.success){
                  arr[i].deviceList=res.result
                }
              }).then(()=>{
                this.get("/VirtualDevice/get", {companyId: arr[i].companyId}).then(res2 => {
                  if(res2.success){
                    res2.result.name='虚拟设备'
                    arr[i].deviceList.unshift(res2.result)
                  }
                }).then(()=>{
                let index = 0
                for(let code of arr[i].deviceCodes){
                  let device = arr[i].deviceList.find(dev=>dev.code == code)
                  if (device) {
                    // this.getDeviceData(companyId,device)
                    // 获取属性值
                    if (code.substr(0, 2) == "_V" && !device.valueList) {
                      this.get('/VirtualDevice/getPropertyValue', {
                        deviceId: device.id
                      }).then(res => {
                        if (res.success) {
                          device.valueList=res.result.map(item=>{
                            item.value=Number(item.value)
                            return item
                          })
                          this.$forceUpdate()
                        }
                      })
                    } else if (!device.valueList) {
                      this.get('/Device/getPropertyValue', {
                        deviceId: device.id
                      }).then(res => {
                        if (res.success) {
                          device.valueList=res.result.map(item=>{
                            item.value=Number(item.value)
                            return item
                          })
                        }
                      })
                    }
                    // 获取设备属性tsl
                    this.getDeviceAttrData(arr[i].companyId, device)
                  }
                  // console.log(i==arr.length-1,i,arr.length-1,index==arr[i].deviceCodes.length-1,index,arr[i].deviceCodes.length-1)
                  if(i==arr.length-1&&index==arr[i].deviceCodes.length-1){
                    this.$set(this.$store.state,'indexPreviewData',arr)
                    this.$set(this.$store.state,'DragList',tree)
                    // console.log(arr)
                    var timer = setTimeout(()=>{
                      console.log('更新视图')
                      // 遍历控件组件
                      if(!this.$refs.control){
                        clearTimeout(timer)
                        return
                      }
                      this.$refs.control.forEach((control)=>{
                        if(control.item.type!="graph"&&control.item.type!="list"&&control.item.type!="ranking"){
                          control.viewUpdate()
                        }
                      })
                      clearTimeout(timer)
                    }, 200);
                  }
                  index+=1
                }
              })
              })
            }
          }else if(i==arr.length-1){
            this.$set(this.$store.state,'indexPreviewData',arr)
            this.$set(this.$store.state,'DragList',tree)
            // 遍历控件组件 更新视图
            if(!this.$refs.control){return}
            this.$refs.control.forEach((control)=>{
              if(control.item.type!="graph"&&control.item.type!="list"&&control.item.type!="ranking"){
                control.viewUpdate()
              }
            })
          }
        }
      },
      // 据企业id，设备对象获取设备属性值
      getDeviceAttrData(companyId, device) {
        // 初次请求过的忽略 !device.attrDataList
        // console.log(device,this.$store.state.productList)
        if (!device.attrDataList) {
          if (device.name == "虚拟设备") {
            this.get('/VirtualDevice/getPropertyList', {
              deviceId: device.id
            }).then(res => {
              if (res.success) {
                device.attrDataList = res.result
              }
            })
          } else {
            let product = this.$store.state.productList.find(item=>item.id==device.productId)
            if(product){
              let data = product.tsl.properties;
              let arr = [];
              if (typeof device.propertySet == 'string') {
                device.propertySet = device.propertySet.split(',')
              }
              for (let item of data) {
                if (device.propertySet.includes(item.identifier)) {
                  item.code = item.identifier
                  item.type = item.dataType.type
                  item.unit = item.dataType.specs?item.dataType.specs.unit:''
                  item.unitName = item.dataType.specs?item.dataType.specs.unitName:''
                  item.step = item.dataType.specs?item.dataType.specs.step:''
                  arr.push(item)
                }
              }
              device.attrDataList = arr
            }else{
              this.get('/ProductFeature/getByDeviceCode', {
                code: device.code
              }).then(res => {
                if (res.success) {
                  let data = JSON.parse(res.result).properties;
                  let arr = [];
                  if (typeof device.propertySet == 'string') {
                    device.propertySet = device.propertySet.split(',')
                  }
                  for (let item of data) {
                    if (device.propertySet.includes(item.identifier)) {
                      item.code = item.identifier
                      item.type = item.dataType.type
                      item.unit = item.dataType.specs?item.dataType.specs.unit:''
                      item.unitName = item.dataType.specs?item.dataType.specs.unitName:''
                      item.step = item.dataType.specs?item.dataType.specs.step:''
                      arr.push(item)
                    }
                  }
                  device.attrDataList = arr
                }
              })
            }
          }
        }
      },
      PushMqtt(url){
        // console.log(this.MqttClient)
        if(!this.mqttUrlList.includes(url)){
          this.mqttUrlList.push(url)
          this.MqttClient.subscribe(url, { qos: 1 })
        }
      },
      /*mqtt消息监听*/
      mqttMSG() {
      	// mqtt连接 预览模式可以多开的情况下避免clientId重复造成mqtt断开出现bug，添加时间戳
        let Time =''
        if(this.$route.path=='/indexPreview'){
          Time = new Date().getTime()
        }
        let MqttOption = {
        	clientId: this.userCode + '_' + this.screen.id + '_indexPreview' + Time,
        	connectTimeout: 600000,
        	clean: true
        }
        this.MqttClient = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, MqttOption)
      	let MqttOption2 = {
      		clientId: this.userCode + '_' + this.screen.id + '_indexPreview_attrBlackBoard' + Time,
      		connectTimeout: 600000,
      		clean: true
      	}
        this.$store.state.subaru = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, MqttOption2)

        this.getMqttMessage()
      },

      /*接收mqtt*/
      getMqttMessage() {
      	// 接收消息处理
        this.MqttClient.on('message', (topic, message) => {
            // console.log(JSON.parse(message.toString()))
      		if(topic.indexOf('/property/push') != -1) {   //设备数据更新推送
            let data = JSON.parse(message.toString()),update=false;
            // 遍历更新控件
            for(let i in this.$store.state.indexPreviewData){
              if(!update){
                // 获取对应设备
                let device = this.$store.state.indexPreviewData[i].deviceList.find(obj =>obj.code==data.deviceCode)
                if(device){
                  update= true
                  let valueList = device.valueList?[...device.valueList]:[]
                  // 格式化mqtt数据
                  for(let key in data.items){
                    let type='',step=0.01
                    if(device.attrDataList){
                      let attr = device.attrDataList.find(attrObj=>attrObj.identifier==key)
                      if(attr){
                        step = attr.step
                        type = attr.dataType.type
                      }
                    }
                    let oldObj = valueList.find(item=>item.code==key)
                    if(oldObj){
                      oldObj.value = this.initValue(data.items[key],type,step)
                      // console.log(oldObj.value,data.items[key] )
                    }else{
                      let obj = {code:key,value:this.initValue(data.items[key],type,step)}
                      valueList.push(obj)
                    }
                  }
                  // console.log(valueList)
                  device.valueList = valueList
                  // 通知更新控件状态
                  if(this.$refs.control){
                    this.$refs.control.forEach((control)=>{
                      if(control.item.type!="graph"&&control.item.type!="list"&&control.item.type!="ranking"){
                        control.viewUpdate(data.deviceCode)
                      }
                    })
                  }
                }
              }
            }
      		}else if(topic.indexOf('/status/push') != -1) {   //设备状态更新推送
            let data = JSON.parse(message.toString())
            let device = this.$store.state.deviceWarningList.find(obj => obj.DeviceCode = data.deviceCode)
            if(device){
              if(!data.alarm.warn&&!data.alarm.error){
                device.status = 0
              }else{
                device.status = 1
              }
            }
      		}
      	})
        // 更新看板数据
      	this.$store.state.subaru.on('message', (topic, message) => {
      		if(topic.indexOf('/property/push') != -1) {
            if(this.$refs.addrobot.$el.style.display == "block"){
              // console.log('block')
              this.$refs.addrobot.UpdateDataByMqtt(topic,message)
            }
      		}
      	})
      },
      // 格式化数据
      initValue(value, type, step) {
        let self = this;
        let returnValue;
        if (!value&&value!=0){
          return null
        }
        if (type == 'int') {
          returnValue = self.common.fmoney(Math.floor(Number(value)));
        } else if (type == 'enum' || type == 'bool') {
          returnValue = Number(value)
        } else if (type == 'date') {
          returnValue = self.changeTimeY(Number(value))
        } else if (type == 'text') {
          returnValue = value
        } else {
          returnValue = self.common.fmoney(Number(value), step)
        }
        return returnValue
      },
      /*展示实时数据*/
      showData(obj) {
      	var self = this;
        // console.log(this.$store.state.mask,new Date())
        // 微信小程序用过webview打开此页面，则跳转回微信小程序的实时数据页面
        if(self.$store.state.openId){
          if(uni){
            self.$store.state.Processing = false
            // 打开设备的实时属性
            if(!obj.controlId||obj.type!="attrSpan"){
              let urlParmes = {
                DeviceCode:obj.DeviceCode,
                DeviceId:obj.DeviceId,
                DeviceName:obj.DeviceName,
                companyId:obj.companyId?obj.companyId:'',
                type:"img"
              }
              uni.navigateTo({
                url:"/pages_company/CompanyConsole/bulletinBoard2?device="+JSON.stringify(urlParmes)
              })
            }else{
              // 打开属性看板关联属性 只能传id到小程序页面，然后在遍历控件获取对应看板
              uni.navigateTo({
                url:"/pages_company/CompanyConsole/bulletinBoard2?controlId="+obj.id
              })
            }
          }
          self.$store.state.Processing = false
        }else if(!self.$store.state.mask&&obj!='close') {
          // console.log(1)
          if(self.isCompany){
            obj.companyId = self.companyId
          }
      		self.$refs.addrobot.binding(obj);
          // return
      		self.$refs.addrobot.$el.style.display = "block";
      		self.$store.state.mask = true;
          self.$refs.addrobot.$children[0].$el.style.top = 0 + 'px';
          self.$refs.addrobot.$el.style.opacity = 1;
      		document.getElementsByClassName('mask')[0].style.transition = '.1s';
          document.getElementsByClassName('mask')[0].style.opacity = '1';
          self.$store.state.Processing = false
      		// document.getElementsByClassName('mask')[0].style.opacity = '0';
      		// document.getElementsByClassName('mask')[0].style.transition = '.1s';
          // console.log("show",new Date())
      		// setTimeout(function() {
      		// 	self.$refs.addrobot.$el.style.opacity = 1;
      		// 	self.$refs.addrobot.$children[0].$el.style.top = 0 + 'px';
      		// 	document.getElementsByClassName('mask')[0].style.opacity = '1';
      		// }, 50)
      	} else if(self.$refs.addrobot){
          // console.log(2)
      		self.$refs.addrobot.$el.style.opacity = 0;
      		self.$refs.addrobot.$children[0].$el.style.top = -50 + 'px';
      		self.$store.state.mask = false;
      		self.$refs.addrobot.$el.style.display = "none";
          // console.log("hide",new Date())
      		// setTimeout(function() {
      		// }, 100)
      	}
      },
      //按键恢复
      keyDownReview () {
        document.onkeydown = function (event) {
          var e = event || window.event;
          e.returnValue = true;
          self.altDown=false
        }
      },
      // 监听alt 展示属性看板
      keyDown () {
        let self = this
        //监听键盘按钮
        window.addEventListener('keydown', e => {
          e=e||window.event;
          var keyCode = e.keyCode || e.which;
          if(keyCode==18){
            self.altDown=true
            e.preventDefault()
          }
        })
        window.addEventListener('keyup', e => {
          e=e||window.event;
          var keyCode = e.keyCode || e.which;
          if(keyCode==18){
            self.altDown=false
            e.preventDefault()
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  #preview{
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    transform-origin: 0 0;
  }
  .isWxapp{
    position: absolute !important;
  }
  .popup{
      position: fixed;
      top: 0;
      left:0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, .4);
      z-index: 99999999;
  }
  .popup>div{
      position: fixed !important;
      top: 0%;
      left:50%;
      padding:0 28px;
      box-sizing: border-box;
      margin-left:-289px;
      width: 578px;
      background-color: #fff;
      z-index: 99999;
      padding-bottom: 30px;
  }
  .popup-title{
      font-size: 16px;
      line-height: 64px;
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 12px;
      text-align: left;
  }
  .popup-lab{
      font-size: 14px;
      line-height: 30px;
      margin-bottom: 14px;
  }
  .btn-box{
      margin-top: 28px;
      width: 100%;
      text-align: center;
  }
  .btn-box .el-button{
      padding: 0 34px !important;
      line-height: 34px !important;
      margin: 0 20px;
  }
  .btn-box2 .el-button{
    margin: 0 10px;
  }
  .b-32{
      position: absolute;
      bottom: 22px;
      left: 0;
  }
  i.close{
      font-size: 20px;
      float: right;
      margin-top: 24px;
  }
  img.notes{
      position: relative;
      left: 8px;
      top: 3px;
  }
  .popup-btn-box{
      text-align: center;
      margin-top: 30px;
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 38px;
  }
  .popup-btn-box .el-button{
      padding: 0 34px !important;
      line-height: 34px !important;
      margin: 0 20px;
  }
</style>
<style>
  #preview .popup .el-input__inner{
      line-height: 34px !important;
      height: 34px !important;
      padding: 0 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/preview/index.vue